import axios from 'axios';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Fade } from '@material-ui/core';
import qs from 'qs';
// import Api from '../Api';
import Header from './Header';
import Navigation from './Navigation';
import Result from './Result';
import Footer from './Footer';

function RubberNavigation() {
    const CHECKBOX_DEFAULT = {
        sekkeiKubun: {
            '1': false,
            '2': false,
        },
        ketashuKubun: {
            '0': false,
            '1': false,
            '2': false,
        },
        keikan: {
            '0': false,
            '1': false,
            '2': false,
            '3': false,
            '4': false,
        },
        area: {
            '0': false,
            '01': false,
            '02': false,
            '03': false,
            '04': false,
            '05': false,
            '06': false,
            '07': false,
            '08': false,
            '09': false,
        },
    };
    const CHART_PARAM = {
        sekkeiKubun: null,
        ketashuKubun: null,
        keikan: null,
        area: null,
        shishoKozoKubun: '',
    };
    const CHART_DATA = {
        data: {},
        legend: {},
        total: 0,
    };
    const FORM_PARAM = {
        companyName: '',
        areaCode: '',
        name: '',
        mail: '',
        tel: '',
        inquiry: '',
    }
    const [step, setStep] = useState({
        count: 0,
        direction: 'left',
    });
    const [naviVisible, setNaviVisible] = useState({
        start: true,
        first: false,
        second: false,
        third: false,
        fource: false,
        search: false,
        button: {display:'none'},
        direction: step.direction,
    });
    const [chartVisibleStyle, setChartVisibleStyle] = useState({visibility: 'hidden'});
    const [checked, setChecked] = useState(CHECKBOX_DEFAULT);
    const [chartParam, setChartParam] = useState(CHART_PARAM);
    const [chartData, setChartData] = useState(CHART_DATA);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [formParam, setFormParam] = useState(FORM_PARAM);
    const firstNaviFlg = useRef(true);
    const searchFlg = useRef(false);
    const searchVisibleFlg = useRef(false);
    const firstVisibleFlg = useRef(true);
    const setFirstVisibleFlg = (val) => {
        firstVisibleFlg.current = val;
    }
    const values = {step, naviVisible, chartVisibleStyle, checked, chartParam, chartData, activeIndex, formParam, firstVisibleFlg, setFirstVisibleFlg};

    const valueClear = () => {
        setChecked(CHECKBOX_DEFAULT);
        setChartParam(CHART_PARAM);
        setChartData(CHART_DATA);
    }
    
    const nextStep = () => {
        let setCount = step.count + 1;
        if (setCount <= 5) {
            if (setCount === 3 && chartParam.sekkeiKubun === '2') {
                setCount = setCount + 1;
            }
            setStep({
                count: setCount,
                direction: 'left',
            });
            console.log('nextStep() - setCount:' + setCount);
        }
        if (setCount >= 5) {
            searchFlg.current = true;
        }
    }

    const prevStep = () => {
        let setCount = step.count - 1;
        if (setCount === 3 && chartParam.sekkeiKubun === '2') {
            setCount = setCount - 1;
        }
        setStep({
            count: setCount,
            direction: 'right',
        });
    }

    const handleChange = (event) => {
        setChecked({
            ...checked,
            [event.target.name]: {
                ...checked[event.target.name],
                [event.target.value]: event.target.checked,
            }
        });
        setChartParam({...chartParam, [event.target.name]: event.target.value});
        console.log('handleChange() - ' + event.target.name + ':' + event.target.value);
    }

    const tabChange = (event, newValue) => {
        setChartParam({
            ...chartParam,
            sekkeiKubun: newValue,
            shishoKozoKubun: "",
        });
        console.log('tabChange() - sekkeiKubun:' + newValue);
    }
    
    const checkboxHandleChange = (event) => {
        var checkedItemVal = event.target.value;
        if (typeof values.chartParam[event.target.name] !== 'undefined') {
            var list = values.chartParam[event.target.name] !== null ? values.chartParam[event.target.name].split(',') : null;
            if (list === null || list[0] === '') {
                list = [];
            }
            if (event.target.checked) {
                list.push(event.target.value);
            } else {
                list.splice(list.indexOf(event.target.value), 1);
            }
            checkedItemVal = list.join(',');
        }
        setChecked({
            ...checked,
            [event.target.name]: {
                ...checked[event.target.name],
                [event.target.value]: event.target.checked,
            }
        });
        setChartParam({
            ...chartParam,
            [event.target.name]: checkedItemVal,
            shishoKozoKubun: "",
        });
        console.log('checkboxHandleChange() - ' + event.target.name + ':' + checkedItemVal);
    };

    const setShishoKozoKubun = (val) => {
        let param = values.chartParam;
        param.shishoKozoKubun = val;
        setChartParam({...chartParam, shishoKozoKubun: val});
        console.log('setShishoKozoKubun() - shishoKozoKubun:' + val);
    }

    const setChartVisible = (val) => {
        setChartVisibleStyle(val);
        console.log('setChartVisible() - chartVisibleStyle:' + val);
    }

    const resetFormParam = () => {
        setFormParam(FORM_PARAM);
        console.log('resetFormParam() - contact form reset');
    }

    const inputChangeHandle = (event) => {
        setFormParam({...formParam, [event.target.name]: event.target.value});
        console.log('inputChangeHandle() - ' + event.target.name + ':' + event.target.value);
    }

    const setActiveIdx = (val) => {
        setActiveIndex(val);
    }
    
    const naviVisibleState = useCallback(() => {
        setNaviVisible({
            start: step.count === 0,
            first: step.count === 1,
            second: step.count === 2,
            third: step.count === 3,
            fource: step.count === 4,
            search: step.count === 5,
            button: step.count < 5 ? {display:'none'} : {},
            direction: step.direction,
        });
        console.log('naviVisibleState() - step:' + JSON.stringify(step));
    }, [step]);

    useEffect(() => {
        if (firstNaviFlg.current) {
            firstNaviFlg.current = false;
            return;
        } else if (step.count < 5) {
            naviVisibleState();
            return;
        }
        if (searchFlg.current) {
            console.log('search() - chartParam:' + JSON.stringify(chartParam));
            axios.get(
                process.env.REACT_APP_API_URL + `search?${qs.stringify(chartParam)}`, {
                headers: {
                    'Content-Type': 'application/json'
                  },
                //   withCredentials: true,
                //   crossDomain: true
            }).then((res) => {
                const data = res.data;
                if (data.status === 200) {
                    if (data.chart.length === 0) {
                        alert('該当するデータがありませんでした。');
                        return false;
                    }
                    searchVisibleFlg.current = true;
                    setFirstVisibleFlg(true);
                    setChartVisibleStyle({});
                    setChartData({
                        data: data.chart,
                        legend: data.legend,
                        total: data.total,
                    });
                    setActiveIndex(0);
                    console.log('setChart() - chartData:' + JSON.stringify(data));
                    naviVisibleState();
                } else {
                    alert("データの取得に失敗しました。");
                }
            });
        }
    }, [step, chartParam, naviVisibleState]);

    return (
        <React.Fragment>
            <Header />
            <Navigation
                prevStep={prevStep}
                nextStep={nextStep}
                valueClear={valueClear}
                handleChange={handleChange}
                values={values} 
            />
            <Fade in={naviVisible.search} mountOnEnter unmountOnExit timeout={{ enter: 1000, exit: 0,}}>
                <div>
                    <Result
                        handleChange={handleChange}
                        tabChange={tabChange}
                        setActiveIndex={setActiveIdx}
                        checkboxHandleChange={checkboxHandleChange}
                        setChartVisibleStyle={setChartVisible}
                        setShishoKozoKubun={setShishoKozoKubun}
                        values={values}
                    />
                </div>
            </Fade>
            <Footer values={values} resetFormParam={resetFormParam} inputChangeHandle={inputChangeHandle} />
        </React.Fragment>
    )
}

export default RubberNavigation;